import { useQuery } from "@apollo/client";
import {
  Autocomplete,
  CircularProgress,
  SxProps,
  TextField,
} from "@mui/material";
import { gql } from "../../__generated__";
import { ProductOrderField } from "../../__generated__/graphql";

interface ProductSelectorProps {
  onChange?: (value: any) => void;
  sx?: SxProps;
  label?: string;
  size?: "medium" | "small";
}

export default function ProductSelector(props: ProductSelectorProps) {
  const { data, error, loading } = useQuery(GET_PRODUCTS, {
    variables: { orderField: ProductOrderField.Name },
  });
  if (error) return <>ERROR</>;
  if (loading) return <CircularProgress />;
  const products = data
    ? data.products.records.map((p) => ({
        id: p.id,
        label: p.translation?.name,
      }))
    : [];

  return (
    <Autocomplete
      sx={{ ...props.sx }}
      size={props.size}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      options={products}
      renderInput={(params) => (
        <TextField {...params} label={props.label || "Product"} />
      )}
      onChange={(_e: any, value) => {
        props.onChange && props.onChange(value?.id || "");
      }}
    />
  );
}

const GET_PRODUCTS = gql(`
  query GetProductsForSelector($orderField: ProductOrderField) {
    products(input: { orderField: $orderField }) {
      records {
        id
        translation(lang: en) {
          name
        }
      }
    }
  }
`);
